<script>
  export let cta
  export let url
  export let color
</script>

<!-- Button -->
<button 
  data-field-label="Button"
  class="label | mr-4 inline-flex text-white border-0 py-2 px-6 focus:outline-none rounded text-lg | {color == 
  'purple' ? 'bg-indigo-500 hover:bg-indigo-600' : 'bg-gray-500 hover:bg-gray-600 '} "
>
  {cta}
</button>